import React, {useMemo} from 'react';
import ListItem from './ListItem';
import List from '@material-ui/core/List';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { Virtuoso } from 'react-virtuoso';

const useStyles = makeStyles((theme) => ({
  list: {
    overflowY: 'auto',
    height: 'calc(100vh - 250px)',
  },
  listItem: {
    paddingTop: 6,
    paddingBottom: 6,
  },
  roomIcon: {
    width: 35,
    height: 35,
  },
  roomName: {
    fontSize: 16,
  },
  message: {
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    'display': '-webkit-box',
    'overflow': 'hidden',
    'fontSize': 12,
  },
  unreadDot: {
    width: 12,
    height: 12,
  },
}));

const ChannelList = ({ rooms, roomId, allRooms, allGroupRooms }) => {
  const classes = useStyles();
  const user = useSelector((s) => s.user.user);

  rooms = allGroupRooms
    ? rooms
        .map((s) => ({
          ...s,
          room: {
            ...s,
            student: s.student,
          },
          unread:
            s.users.length > 0
              ? s.last_message_timestamp > s.users[0].last_activity ||
                s.last_activity === null
              : true,
        }))
        .sort(
          (b, a) =>
            new Date(a.last_message_timestamp) -
            new Date(b.last_message_timestamp),
        )
    : allRooms
    ? rooms.map((s) => ({
        ...s,
        room: {
          ...s,
          student: s.student,
        },
      }))
    : rooms;

  const Components = useMemo(() => {
    return {
      List: React.forwardRef(({ style, children }, listRef) => {
        return (
          <List
            style={{padding: 0, ...style, margin: 0}}
            ref={listRef}
          >
            {children}
          </List>
        );
      }),
    };
  }, []);

  return (
    <Virtuoso
      components={Components}
      style={{
        height: 'calc(100vh - 210px)',
      }}
      data={rooms}
      itemContent={(index, item) => (
        <ListItem
          key={item.id}
          room={item}
          user={user}
          selected={item.id === Number(roomId)}
          classes={classes}
        />
      )}
    />
  )
};

export default React.memo(ChannelList);
